export default {
    title: '',
    with_comment: false,
    order: 0,
};

